import { render, staticRenderFns } from "./UploadStatements.vue?vue&type=template&id=3a1b3524&scoped=true&"
import script from "./UploadStatements.vue?vue&type=script&lang=js&"
export * from "./UploadStatements.vue?vue&type=script&lang=js&"
import style0 from "./UploadStatements.vue?vue&type=style&index=0&id=3a1b3524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1b3524",
  null
  
)

export default component.exports